import {TransportRoute} from "../../../../model/location-history";
import {Polyline} from "@react-google-maps/api";
import React from "react";

export type TransportRoutePolylineProps = {
  route: TransportRoute
}

export const TransportRoutePolyline = (props: TransportRoutePolylineProps) => {
  const {route} = props;
  return (
    <Polyline
      key={route.transport.id}
      path={route.route.map((crd) => {
        return {lat: crd.latCoord, lng: crd.longCoord};
      })}
      options={{
        strokeColor: route.color,
      }}
    />
  );
};

export const TransportRoutePolylineMemo = React.memo(TransportRoutePolyline);
